<template>
    <div>
        <div class="Panel">
            <div class="Panel__heading">Roles</div>
            <div class="Panel__body">
                <div class="TableResponsive">
                    <table class="Table Table--striped Table--admin">
                        <thead>
                        <tr>
                            <th>Role</th>
                        </tr>

                        <tr>
                            <td colspan="2">
                                <div class="Form__input-group">
                                    <a href="#" class="Form__addon" @click.prevent="createRole">Create Role</a>
                                    <input type="text" class="Form__text" v-model.trim="roleLabel"
                                           @keyup.enter="createRole">
                                </div>
                                <div class="Form__error">{{ error }}</div>
                            </td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="role in sortedRoles">
                            <td class="Table__cell--clickable" @click="showRolePermissions(role)">{{ role.label }}</td>
                            <td class="Table__cell--control">
                                <a href="#" class="Table__control Table__control--danger"
                                   @click.prevent="deleteRole(role.id)">
                                    <i class="fa fa-trash-o fa-fw" aria-hidden="true"></i>
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="Panel" v-show="selectedRole">
            <div class="Panel__heading">{{ selectedRole.label }} Permissions</div>
            <div class="Panel__body">
                <table class="Table Table--striped Table--admin">
                    <tbody v-for="group in permissionGroups">
                        <tr>
                            <td class="Table__cell--section-title" colspan="2">{{ group.name }}</td>
                        </tr>
                        <tr v-for="permission in group.permissions">
                            <td>{{ permission.label }}</td>
                            <td class="Table__cell--number" v-if="! hasChildPermissions(permission)">
                                <input type="checkbox"
                                       :value="permission.id"
                                       v-model="selectedRolePermissions[permission.name]"
                                       @click="updatePermissions"
                                >
                            </td>
                            <td class="Table__cell--form-field Table__cell--number" style="width: 250px;" v-else>
                                <div class="Form__select">
                                    <select v-model="selectedRolePermissions[permission.name]" @change="updatePermissions">
                                        <option :value="option.id"
                                                v-for="option in permission.children"
                                        >
                                            {{ option.label }}
                                        </option>
                                    </select>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                roleLabel: '',
                error: '',
                selectedRole: '',
                selectedRolePermissions: {},
                roles: {},
                permissionGroups: {}
            }
        },

        props: {
            currentRoles: {
                required: true,
            },

            availablePermissionGroups: {
                required: true
            }
        },

        mounted() {
            this.roles = JSON.parse(this.currentRoles);
            this.permissionGroups = JSON.parse(this.availablePermissionGroups)
        },

        computed: {
            sortedRoles() {
                return _.sortBy(this.roles, (role) => {
                    return role.label.toLowerCase();
                });
            },

            roleName() {
                return _.snakeCase(this.roleLabel);
            },
        },

        methods: {
            createRole() {
                if (this.roleLabel.trim() == '') {
                    return this.error = 'Role name is required';
                }

                this.error = '';

                this.$http.post('/system-settings/account-management/roles', {
                    label: this.roleLabel,
                    name: this.roleName,
                }).then((response) => {
                    this.roles.push(response.data);
                    this.roleLabel = '';
                }).catch((error) => {
                    this.error = _.head(_.head(_.values(error.response.data)));
                })
            },

            deleteRole(id) {
                if (this.selectedRole.id == id) {
                    this.selectedRole = '';
                }

                this.$http.delete('/system-settings/account-management/roles/' + id).then((response) => {
                    this.roles = response.data;
                })
            },

            showRolePermissions(role) {
                this.selectedRole = role;
                this.setSelectedRolePermissions();
                this.$forceUpdate();
            },

            hasChildPermissions(permission) {
                return ! _.isEmpty(permission.children);
            },

            isChildPermission(permission) {
                return _.isObject(permission.parent);
            },

            hasPermission(permission) {
                if (this.selectedRole == '') return false;

                return _.includes(this.selectedRolePermissions, permission);
            },

            setSelectedRolePermissions() {
                if (this.selectedRole == '') return {};

                let permissions = {}

                _.each(this.permissionGroups, function (permissionGroup) {
                    _.each(permissionGroup.permissions, function (permission) {
                        var value;

                        let name = permission.name;

                        if (this.hasChildPermissions(permission)) {
                            let permissionIsSet = this.childPermissionIsSet(permission.children);

                            if (permissionIsSet) {
                                value = permissionIsSet;
                            } else {
                                value = permission.children[0].id;
                            }
                        } else {
                            if (_.find(this.selectedRole.permissions, ['id', permission.id])) {
                                value = true;
                            } else {
                                value = false;
                            }
                        }

                        _.set(permissions, name, value);
                    }.bind(this));
                }.bind(this));

                this.selectedRolePermissions = permissions;
            },

            childPermissionIsSet(children) {
                let childId = false;

                let childIds = _.map(children, function (child) {
                    return child.id;
                })

                _.each(this.selectedRole.permissions, function (permission) {
                    if (childIds.indexOf(permission.id) >= 0) childId = permission.id;
                })

                return childId;
            },

            updatePermissions() {
                setTimeout(() => {
                    this.$http.patch(
                        '/system-settings/account-management/roles/' + this.selectedRole.id, {
                            permissions: this.selectedRolePermissions
                    }).then((response) => {
                        let roleIndex = _.findIndex(this.roles, ['id', this.selectedRole.id]);

                        this.roles = response.data;
                    });
                }, 100);
            }
        }
    }
</script>